<template>
  <div class="layout-footer" ref="footer">
    <div class="footer-top"></div>
    <div class="footer-center">
      <div class="center-content">
        <div class="content-top">
          <img
            class="footer-logo"
            src="@/assets/images/footer-logo.png"
            alt=""
          />
        </div>
        <div class="content-bottom">
          <div class="first">
            <div class="label-item">主办单位：重庆昭信教育科技集团有限公司</div>
            <div class="label-item">联系我们：023-62602200</div>
            <div class="label-item">技术支持：重庆市渝北区嘉州路38号3楼</div>
          </div>
          <div class="second">
            <div class="label-item">友情链接：</div>
            <div
              class="label-item link-item"
              @click="handlerUrl('https://www.smartedu.cn/')"
            >
              国家智慧教育公共服务平台：https://www.smartedu.cn
            </div>
            <div
              class="label-item link-item"
              @click="handlerUrl('https://jw.cq.gov.cn/')"
            >
              重庆市教育委员会：https://jw.cq.gov.cn
            </div>
          </div>
          <div class="third"></div>
          <div class="four">
            <div
              class="corporation-item link-item"
              @click="handlerUrl('https://www.zx-edu.com.cn/')"
            >
              公司介绍
            </div>
            <div
              class="corporation-item link-item"
              @click="
                handlerUrl(
                  'https://www.zx-edu.com.cn/handsInZX/cooperation.html'
                )
              "
            >
              联系我们
            </div>
            <div
              class="corporation-item link-item"
              @click="
                handlerUrl(
                  'https://www.zx-edu.com.cn/handsInZX/cooperation.html'
                )
              "
            >
              招商合作
            </div>
            <div
              class="corporation-item link-item"
              @click="
                handlerUrl(
                  'https://www.zx-edu.com.cn/handsInZX/cooperation.html'
                )
              "
            >
              合作伙伴
            </div>
          </div>
          <div class="five">
            <div class="logo-item">
              <img class="logo-img" src="@/assets/images/zxjyyjy.png" alt="" />
              <div class="logo-mc">昭信教育研究院</div>
            </div>
            <div class="logo-item">
              <img class="logo-img" src="@/assets/images/zxjykjjt.png" alt="" />
              <div class="logo-mc">昭信教育科技集团</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      昭信教育版权所有&nbsp;&nbsp;&nbsp;渝ICP备14007033号2021&nbsp;ZhaoXin&nbsp;Education&nbsp;CORPORATION&nbsp;All&nbsp;Rights&nbsp;Reserved&nbsp;&nbsp;&nbsp;渝公网安备&nbsp;50011202502946号
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
export default {
  data() {
    return {
      timeline: null,
    };
  },
  methods: {
    handlerUrl(url) {
      window.open(url);
    },
    // 初始动画
    initAnimate() {
      if (this.timeline) this.timeline.kill();
      this.timeline = gsap.timeline();
      this.timeline
        .to(this.$refs.footer, {
          duration: 1,
          ease: "power2.out",
        })
        .fromTo(
          ".layout-footer",
          {
            opacity: 0,
            y: 100,
          },
          {
            opacity: 1,
            y: 0,
            stagger: 0.1,
            duration: 1,
            ease: "back.out(1.7)",
          },
          "<0.2"
        );
    },
  },
  mounted() {
    this.initAnimate();
  },
};
</script>

<style lang="scss" scoped>
.layout-footer {
  .footer-top {
    width: 100vw;
    height: 4px;
    background-color: #00ffe3;
  }

  .footer-center {
    width: 100vw;
    height: 277px;
    background-image: url("@/assets/images/footer-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;

    .link-item {
      cursor: pointer;
    }

    .center-content {
      width: 1200px;
      height: 277px;

      .content-top {
        padding-top: 39px;

        .footer-logo {
          width: 398px;
          height: 63px;
        }
      }

      .content-bottom {
        height: 128px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;

        .first,
        .second {
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;

          .label-item {
            margin-bottom: 13px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .second {
          margin-left: 24px;
        }

        .third {
          margin-left: 28px;
          width: 1px;
          height: 100px;
          background-color: #ffffff;
        }

        .four {
          margin-left: 34px;
          width: 238px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;

          .corporation-item {
            margin-bottom: 16px;
            width: 111px;
            height: 39px;
            border-radius: 8px;
            border: 1px solid #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;

            &:nth-child(3) {
              margin-bottom: 0;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .five {
          margin-left: 55px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;

          .logo-item {
            width: 128px;
            height: 128px;
            background-color: #ffffff;
            position: relative;

            .logo-img {
              width: 128px;
              height: 128px;
            }

            &:nth-child(2) {
              margin-left: 22px;
            }

            .logo-mc {
              position: absolute;
              bottom: -20px;
              left: 0;
              width: 128px;
              font-weight: 400;
              font-size: 10px;
              color: #ffffff;
              text-align: center;
            }
          }
        }
      }
    }
  }

  .footer-bottom {
    width: 100vw;
    height: 63px;
    background-color: #0065d6;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
    font-family: "Times new Roman";
  }
}
</style>
